import React, { useState } from 'react';
import '../styles/ChatBox.css';
import { baseUrl } from '../config';



const ChatBox = ({ onEffectApplied }) => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');

  const sendMessage = (text, sender) => {
    const newMessage = { text, sender, id: messages.length + 1 };
    setMessages([...messages, newMessage]);
  };

  const handleSend = () => {
    if (input.trim()) {
      sendMessage(input, 'user');
      // Simulate AI response
      handleAIResponse(input);
      setInput('');
    }
  };

  const handleAIResponse = (userInput) => {
    // Placeholder for AI logic
    // The AI would interpret the userInput, apply effects, and respond back

    const aiResponse = `Applying "${userInput}" effect to the video...`;
    sendMessage(aiResponse, 'ai');

    // Simulate effect being applied
    setTimeout(() => {
      const resultMessage = `The video has been edited with the "${userInput}" effect.`;
      sendMessage(resultMessage, 'ai');
      
      // Call the onEffectApplied prop to indicate the effect is applied
      if (onEffectApplied) {
        onEffectApplied(userInput);
      }
    }, 2000);
  };

  return (
    <div className="chat-box">
      <div className="chat-messages">
        {messages.map((message) => (
          <div
            key={message.id}
            className={`chat-message ${message.sender === 'user' ? 'user' : 'ai'}`}
          >
            {message.text}
          </div>
        ))}
      </div>
      <div className="chat-input">
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Describe the effect you need..."
        />
        <button onClick={handleSend}>Send</button>
      </div>
    </div>
  );
};

export default ChatBox;

